var video_viewer_default = {
  "video_player": "wvZpi",
  "videoOverlay": "Wf9Xl",
  "video_container": "LqvMN"
};
export {
  video_viewer_default as default
};
//# sourceMappingURL=video-viewer-scss.js.map
